module.exports = __webpack_public_path__ + "static/img/zhuanli.42cf2dbe.png";